import { http } from '../services';

class CriterioService {
    criterioForm() {
        return http.get('/criterios/form');
    }

    async getCriterios(projeto) {
        return http.get('/criterios', {
            projeto,
        });
    }

    getCriterio(codigo) {
        return http.get(`/criterios/${codigo}`);
    }

    save(criterio) {
        return http.post('/criterios', criterio);
    }

    update(criterio) {
        return http.put('/criterios', criterio);
    }

    delete(criterio) {
        return http.delete('/criterios', criterio);
    }
}

const criterioService = new CriterioService();
export default criterioService;
